import React from 'react'

const skeletonBase = {
    backgroundColor: '#e5e7eb',
    borderRadius: '6px',
}

const FeedSkeleton = ({ count = 2 }) => {
    return (
        <div className="feed-list">
            <div className="animate-pulse" style={{ display: 'flex', flexDirection: 'column', gap: '24px', animation: 'pulse 1.5s infinite', padding: '35px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row' }}>
                    {/* Feed title skeleton */}
                    <div style={{ ...skeletonBase, width: '100px', height: '32px' }} />

                    {/* Search input skeleton */}
                    <div style={{ position: 'relative', width: '292px' }}>
                        <div style={{ ...skeletonBase, width: '100%', height: '42px' }} />
                        <div
                            style={{
                                ...skeletonBase,
                                width: '16px',
                                height: '16px',
                                borderRadius: '4px',
                                position: 'absolute',
                                right: '10px',
                                top: '8px',
                            }}
                        />
                    </div>
                </div>

                <div className="scroll-feeds grey-small-scroll" style={{ marginTop: 20 }}>
                    {/* Feed items skeleton */}
                    {Array.from({ length: count }).map((_, i) => (
                        <div
                            className={`post-feed`}
                            key={i}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                padding: '16px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                {/* Image skeleton */}
                                <div style={{ ...skeletonBase, width: '80px', height: '80px', flexShrink: 0 }} />

                                {/* Text skeletons */}
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <div style={{ ...skeletonBase, width: '60%', height: '20px' }} />
                                    <div style={{ ...skeletonBase, width: '40%', height: '16px' }} />
                                    <div style={{ ...skeletonBase, width: '30%', height: '14px' }} />
                                </div>

                                {/* Like icon skeleton */}
                                <div style={{ ...skeletonBase, width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0, alignSelf: 'flex-end' }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default FeedSkeleton
